import { CalendarDays, Award, ShieldCheck, MapPinned } from "lucide-react";

const ITEMS = [
  { icon: CalendarDays, value: "9 Years", label: "In Business" },
  { icon: Award, value: "25+ Years", label: "Combined Experience" },
  { icon: ShieldCheck, value: "Qualified", label: "Trade Professionals" },
  { icon: MapPinned, value: "VIC & NSW", label: "Service Coverage" },
];

export const TrustBar = () => (
  <section data-testid="trust-bar" className="bg-brand-blue text-white">
    <div className="mx-auto max-w-7xl grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
      {ITEMS.map((it) => (
        <div key={it.label} className="flex flex-col items-center gap-2 px-4 py-9 text-center">
          <it.icon className="h-6 w-6 text-brand-gold" strokeWidth={1.5} />
          <div className="font-display text-2xl md:text-3xl font-bold">{it.value}</div>
          <div className="text-xs md:text-sm uppercase tracking-wider text-slate-400">{it.label}</div>
        </div>
      ))}
    </div>
  </section>
);
